<mat-card class="invitation-container" *ngIf="invitationResourceStrings">
    <mat-card-header class="invitation-header">
        <fa-icon class="close btn-close" aria-hidden="true" (click)="hideInvitation(CloseReason.ByUser)" [icon]="faTimes"></fa-icon>
    </mat-card-header>
    <mat-card-content *ngIf="error; else invitationView" class="error-message">
        <p>{{error}}</p>
    </mat-card-content>
    <ng-template #invitationView>
        <ng-container *ngIf="invitationResourceStrings.SubmitButtonText; else clickableInvitation">
            <mat-card-content class="invitation-message">
                <div>
                    <p>{{invitationResourceStrings.InvitationText}}</p>
                </div>
            </mat-card-content>
            <mat-card-actions class="invitation-actions">
                <button mat-button color="primary" (click)="acceptInvitation()">{{invitationResourceStrings.SubmitButtonText}}</button>
            </mat-card-actions>
        </ng-container>
        <ng-template #clickableInvitation>
            <mat-card-content class="invitation-message clickable" (click)="acceptInvitation()">
                <div>
                    <p>{{invitationResourceStrings.InvitationText}}</p>
                </div>
            </mat-card-content>
        </ng-template>
    </ng-template>
</mat-card>
